const actions = {
  CREATE_SUBSCRIPTION_PACKAGE_BEGIN: "CREATE_SUBSCRIPTION_PACKAGE_BEGIN",
  CREATE_SUBSCRIPTION_PACKAGE_SUCCESS: "CREATE_SUBSCRIPTION_PACKAGE_SUCCESS",
  CREATE_SUBSCRIPTION_PACKAGE_ERR: "CREATE_SUBSCRIPTION_PACKAGE_ERR",

  LIST_SUBSCRIPTION_PACKAGES_BEGIN: "LIST_SUBSCRIPTION_PACKAGES_BEGIN",
  LIST_SUBSCRIPTION_PACKAGES_SUCCESS: "LIST_SUBSCRIPTION_PACKAGES_SUCCESS",
  LIST_SUBSCRIPTION_PACKAGES_ERR: "LIST_SUBSCRIPTION_PACKAGES_ERR",

  UPDATE_SUBSCRIPTION_PACKAGE_BEGIN: "UPDATE_SUBSCRIPTION_PACKAGE_BEGIN",
  UPDATE_SUBSCRIPTION_PACKAGE_SUCCESS: "UPDATE_SUBSCRIPTION_PACKAGE_SUCCESS",
  UPDATE_SUBSCRIPTION_PACKAGE_ERR: "UPDATE_SUBSCRIPTION_PACKAGE_ERR",

  DELETE_SUBSCRIPTION_PACKAGE_BEGIN: "DELETE_SUBSCRIPTION_PACKAGE_BEGIN",
  DELETE_SUBSCRIPTION_PACKAGE_SUCCESS: "DELETE_SUBSCRIPTION_PACKAGE_SUCCESS",
  DELETE_SUBSCRIPTION_PACKAGE_ERR: "DELETE_SUBSCRIPTION_PACKAGE_ERR",

  BLOCK_SUBSCRIPTION_PACKAGE_BEGIN: "BLOCK_SUBSCRIPTION_PACKAGE_BEGIN",
  BLOCK_SUBSCRIPTION_PACKAGE_SUCCESS: "BLOCK_SUBSCRIPTION_PACKAGE_SUCCESS",
  BLOCK_SUBSCRIPTION_PACKAGE_ERR: "BLOCK_SUBSCRIPTION_PACKAGE_ERR",

  UNBLOCK_SUBSCRIPTION_PACKAGE_BEGIN: "UNBLOCK_SUBSCRIPTION_PACKAGE_BEGIN",
  UNBLOCK_SUBSCRIPTION_PACKAGE_SUCCESS: "UNBLOCK_SUBSCRIPTION_PACKAGE_SUCCESS",
  UNBLOCK_SUBSCRIPTION_PACKAGE_ERR: "UNBLOCK_SUBSCRIPTION_PACKAGE_ERR",

  GET_SUBSCRIPTION_PACKAGE_DETAILS_BEGIN:
    "GET_SUBSCRIPTION_PACKAGE_DETAILS_BEGIN",
  GET_SUBSCRIPTION_PACKAGE_DETAILS_SUCCESS:
    "GET_SUBSCRIPTION_PACKAGE_DETAILS_SUCCESS",
  GET_SUBSCRIPTION_PACKAGE_DETAILS_ERR: "GET_SUBSCRIPTION_PACKAGE_DETAILS_ERR",

  createSubscriptionPackageBegin: () => {
    return {
      type: actions.CREATE_SUBSCRIPTION_PACKAGE_BEGIN,
    };
  },

  createSubscriptionPackageSuccess: (data) => {
    return {
      type: actions.CREATE_SUBSCRIPTION_PACKAGE_SUCCESS,
      data,
    };
  },

  createSubscriptionPackageErr: (err) => {
    return {
      type: actions.CREATE_SUBSCRIPTION_PACKAGE_ERR,
      err,
    };
  },

  listSubscriptionPackagesBegin: () => {
    return {
      type: actions.LIST_SUBSCRIPTION_PACKAGES_BEGIN,
    };
  },

  listSubscriptionPackagesSuccess: (data) => {
    return {
      type: actions.LIST_SUBSCRIPTION_PACKAGES_SUCCESS,
      data,
    };
  },

  listSubscriptionPackagesErr: (err) => {
    return {
      type: actions.LIST_SUBSCRIPTION_PACKAGES_ERR,
      err,
    };
  },

  updateSubscriptionPackageBegin: () => {
    return {
      type: actions.UPDATE_SUBSCRIPTION_PACKAGE_BEGIN,
    };
  },

  updateSubscriptionPackageSuccess: (data) => {
    return {
      type: actions.UPDATE_SUBSCRIPTION_PACKAGE_SUCCESS,
      data,
    };
  },

  updateSubscriptionPackageErr: (err) => {
    return {
      type: actions.UPDATE_SUBSCRIPTION_PACKAGE_ERR,
      err,
    };
  },

  deleteSubscriptionPackageBegin: () => {
    return {
      type: actions.DELETE_SUBSCRIPTION_PACKAGE_BEGIN,
    };
  },

  deleteSubscriptionPackageSuccess: (data) => {
    return {
      type: actions.DELETE_SUBSCRIPTION_PACKAGE_SUCCESS,
      data,
    };
  },

  deleteSubscriptionPackageErr: (err) => {
    return {
      type: actions.DELETE_SUBSCRIPTION_PACKAGE_ERR,
      err,
    };
  },

  blockSubscriptionPackageBegin: () => {
    return {
      type: actions.BLOCK_SUBSCRIPTION_PACKAGE_BEGIN,
    };
  },

  blockSubscriptionPackageSuccess: (data) => {
    return {
      type: actions.BLOCK_SUBSCRIPTION_PACKAGE_SUCCESS,
      data,
    };
  },

  blockSubscriptionPackageErr: (err) => {
    return {
      type: actions.BLOCK_SUBSCRIPTION_PACKAGE_ERR,
      err,
    };
  },

  unblockSubscriptionPackageBegin: () => {
    return {
      type: actions.UNBLOCK_SUBSCRIPTION_PACKAGE_BEGIN,
    };
  },

  unblockSubscriptionPackageSuccess: (data) => {
    return {
      type: actions.UNBLOCK_SUBSCRIPTION_PACKAGE_SUCCESS,
      data,
    };
  },

  unblockSubscriptionPackageErr: (err) => {
    return {
      type: actions.UNBLOCK_SUBSCRIPTION_PACKAGE_ERR,
      err,
    };
  },

  getSubscriptionPackageDetailsBegin: () => {
    return {
      type: actions.GET_SUBSCRIPTION_PACKAGE_DETAILS_BEGIN,
    };
  },

  getSubscriptionPackageDetailsSuccess: (data) => {
    return {
      type: actions.GET_SUBSCRIPTION_PACKAGE_DETAILS_SUCCESS,
      data,
    };
  },

  getSubscriptionPackageDetailsErr: (err) => {
    return {
      type: actions.GET_SUBSCRIPTION_PACKAGE_DETAILS_ERR,
      err,
    };
  },
};

export default actions;
